import React from "react"
import useForm from "hooks/useForm"
import ContextForm from "./ContextForm"

const StatefulForm = ({
  id = undefined,
  className,
  initialState,
  loading = undefined,
  schema,
  children,
  onSubmit,
}) => {
  const { state, focused, errors, focus, change, add, remove, submit } =
    useForm({
      initialState,
      schema,
    })
  function handleSubmit(state, errors) {
    submit()
    onSubmit(schema.cast(state, { stripUnknown: true }), errors)
  }
  return (
    <ContextForm
      id={id}
      className={className}
      loading={loading}
      onSubmit={handleSubmit}
      source={state}
      onFocus={focus}
      focused={focused}
      onAdd={add}
      onChange={change}
      onRemove={remove}
      errors={errors}
    >
      {children}
    </ContextForm>
  )
}
export default StatefulForm
